import React, { useState } from 'react';
import { Typography } from '../../../../atoms/typography/Typography';

const CompareRenderOptionsValue = ({ title }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [titleItem] = Array.isArray(title) ? title : [title];

  const maxTitleLength = 14;
  return (
    <Typography
      title={titleItem}
      className="lg:line-clamp-2 lg:self-center lg:h-fit max-lg:max-w-40"
    >
      {(titleItem?.length <= maxTitleLength || isOpen) && (
        <Typography as="span" fontVariant="sm" className="ml-2">
          {titleItem}
        </Typography>
      )}
      {titleItem?.length > maxTitleLength && !isOpen && (
        <Typography
          as="span"
          fontVariant="sm"
          className="ml-2 global-hover"
          onClick={() => setIsOpen(!isOpen)}
        >
          {titleItem.substring(0, maxTitleLength - 5)}...
        </Typography>
      )}
    </Typography>
  );
};

export default CompareRenderOptionsValue;
